import type { Configuracoes } from '@peniel/shared'

import { apiFetch } from './client.js'

export function obterConfigLoja(): Promise<Configuracoes> {
  return apiFetch('/configuracoes')
}
